import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h3 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --iconColour: ${brand.primary.white};

  position: relative;
  overflow: clip;

  &[data-variant='purple'] {
    --gradient: 90deg;
    --sectionBackground: linear-gradient(var(--gradient), #9f4a92 0%, #3271a9 100%);
    --sectionColour: ${brand.primary.white};
  }

  &[data-variant='blue'],
  &[data-variant='purple'] {
    --titleHighlight: ${brand.tertiary.sun};
  }

  &[data-variant='white'] {
    --iconColour: ${brand.primary.orange};
  }

  @media ${from(Device.TabletLarge)} {
    &[data-invert='true'] {
      --gradient: 270deg;
    }
  }

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};

    row-gap: ${fluid(32, 40, Device.MobileLarge, Device.TabletSmall)};
  }
`;
const ContentWrapper = styled(m.div) `
  position: relative;
  z-index: 1;
  grid-column: 1 / span 12;
  margin: auto 0;

  @media ${from(Device.TabletSmall)} {
    grid-column: 3 / span 8;
  }

  @media ${from(Device.TabletLarge)} {
    --col: 7;

    grid-column: var(--col) / span 6;
    grid-row: 1 / span 1;

    ${Container}[data-invert='true'] & {
      --col: 1;
    }
  }

  @media ${from(Device.TabletLarge)} {
    --col: 8;

    grid-column: var(--col) / span 5;
  }
`;
const Title = styled(m.h2) `
  ${h3};

  margin-bottom: ${fluid(16, 24)};

  span[data-highlight] {
    background: var(--titleHighlight, currentColor);
    background-clip: text;
    color: transparent;
    display: inline;
  }
`;
const TitleWord = styled(m.span) `
  &:not(:last-child) {
    margin-right: 0.4ch;
  }
`;
const Content = styled(m.div) `
  ${contentStyles};
`;
const CtaWrapper = styled(m.div) `
  margin-top: ${fluid(16, 40)};
  display: flex;
  gap: ${fluid(8, 24)};
  flex-wrap: wrap;
`;
const ImageWrapper = styled(m.div) `
  ${imageWrapperPreserveRatio(768, 428)};

  z-index: 1;
  grid-column: 1 / span 12;
  border-radius: ${fluid(20, 48)};
  margin: auto 0;

  @media ${until(Device.TabletSmall)} {
    ${Container}[data-invert='true'] & {
      grid-row: 2 / span 1;
    }
  }

  @media ${from(Device.TabletSmall)} {
    grid-column: 3 / span 8;
  }

  @media ${from(Device.TabletLarge)} {
    --col: 1;

    grid-column: var(--col) / span 6;

    ${Container}[data-invert='true'] & {
      --col: 7;
    }
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const BrandingIcon = styled(m.div) `
  --width: ${fluid(200, 460)};

  position: absolute;
  top: calc(var(--width) * -0.15);
  right: calc(var(--width) * -0.4);
  width: var(--width);
  aspect-ratio: 1;
  color: var(--iconColour);
  opacity: 0.08;
  transform: translateX(40%);

  svg {
    display: block;
    width: 100%;
  }

  ${Container}[data-variant='charcoal'] & {
    display: none;
  }

  @media ${until(Device.TabletLarge)} {
    ${Container}[data-invert='false'] & {
      top: auto;
      bottom: calc(var(--width) * -0.15);
    }
  }
`;
const ImageText5050Styles = {
    Container,
    ContentWrapper,
    ImageWrapper,
    Image,
    Title,
    TitleWord,
    Content,
    CtaWrapper,
    BrandingIcon,
};
export default ImageText5050Styles;
